import React from 'react';
import "./carousel.css";
import Link from 'gatsby-link';
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'

let screen = (typeof window !== `undefined`) ? window.innerWidth : 1400;

const InfoSection = (props) => (
  <div style={{textAlign: (screen <= 480) ? 'center' : 'unset', marginBottom: 15}}>
    <img src={props.photo} alt="" style={{marginBottom: 0}} />
    <Typography variant="caption" style={{fontWeight: 'bold'}} color='caption'>
      {props.title}
    </Typography>
    <Divider style={{ backgroundColor: '#9E9E9E', opacity: '0.3', margin: 5, }}/>
    <Link to={props.linkOne} style={{display: 'contents'}}>
      <Typography variant="caption" style={{marginBottom: 5}} color='primary'>
        {(props.linkThree) ? 'Parte 1: 1930 - 1945' : props.titleSection1}
      </Typography>
    </Link>
    <Link to={props.linkTwo} style={{display: 'contents'}}>
      <Typography variant="caption" color='primary'>
        {(props.linkThree) ? 'Parte 2: 1945 - 1955' : props.titleSection2}
      </Typography>
    </Link>
    {
      (props.linkThree) ?
        <Link to={props.linkThree} style={{display: 'contents'}}>
          <Typography variant="caption" style={{marginTop: 5}} color='primary'>
            Parte 3: 1955 - 1983
          </Typography>
        </Link> :
        (props.linkThreeActual) ?
        <Link to={props.linkThree} style={{display: 'contents'}}>
          <Typography variant="caption" style={{marginTop: 5}} color='primary'>
            {props.titleSection3}
          </Typography>
        </Link> :
        null
    }
  </div>
)

InfoSection.defaultProps = {
  titleSection1: 'Parte 1: Política Interna',
  titleSection2: 'Parte 2: Política Externa, Economía, Sociedad, Cultura',
};

export default InfoSection



// WEBPACK FOOTER //
// ./src/components/infoSection.js